
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/components/AuthProvider";
import { useLanguage } from "@/components/LanguageContext";
import { useTranslations } from "./useTranslations";

export function useStudentLimit() {
  const { user } = useAuth();
  const { language } = useLanguage();
  const { t } = useTranslations("students");

  const { data: studentsCount, isLoading: isLoadingCount } = useQuery({
    queryKey: ["students-count", user?.id],
    queryFn: async () => {
      if (!user?.id) return 0;

      const { count, error } = await supabase
        .from("students")
        .select("id", { count: 'exact', head: true })
        .eq("trainer_id", user.id);

      if (error) {
        console.error("Error fetching student count:", error);
        return 0;
      }
      
      return count || 0;
    },
    enabled: !!user?.id,
    staleTime: 0
  });
  
  const currentCount = studentsCount || 0;
  const limitMessage = t("studentLimit.total").replace("{current}", currentCount.toString());

  return {
    currentCount,
    limitMessage,
    isLoading: isLoadingCount,
  };
}
